import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { BuyComponent } from './pages/buy/buy.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'Murder Nights · Presentación' },
  { path: 'comprar', component: BuyComponent, title: 'Comprar Murder Nights' },
  { path: '**', redirectTo: '' }
];
